"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const muiIconButton = {
    styleOverrides: {
        root: {
            width: '48px',
            height: '48px',
            '&.Mui-disabled': {
                opacity: 1,
                color: 'rgba(0, 0, 0, 0.6)',
            },
        },
    },
};
exports.default = muiIconButton;
//# sourceMappingURL=muiIconButton.js.map